export const storefront = {
  header: {
    brandFallback: 'Tickets',
    conferences: 'Konferenzen',
    about: 'Über uns',
    myTickets: 'Meine Tickets',
    profile: 'Profil',
    memberships: 'Mitgliedschaften',
    signOut: 'Abmelden',
    signIn: 'Anmelden',
    register: 'Registrieren',
  },
  footer: {
    needHelp: 'Brauchen Sie Hilfe? Kontaktieren Sie den Veranstalter.',
    explore: 'Entdecken',
    events: 'Veranstaltungen',
    about: 'Über uns',
    myTickets: 'Meine Tickets',
    help: 'Hilfe',
    helpBody: 'Fragen zu Ihrer Buchung? Kontaktieren Sie den Veranstalter direkt und geben Sie Ihre Bestellreferenz an.',
    allRightsReserved: 'Alle Rechte vorbehalten.',
    poweredBy: 'Bereitgestellt von Selwyn',
  },
  eventList: {
    loading: 'Veranstaltungen werden geladen...',
    title: 'Kommende Veranstaltungen',
    searchPlaceholder: 'Veranstaltungen suchen…',
    gridViewTitle: 'Rasteransicht',
    calendarViewTitle: 'Kalenderansicht',
    dateFilterAll: 'Alle',
    dateFilterWeek: 'Diese Woche',
    dateFilterMonth: 'Diesen Monat',
    categoryAll: 'Alle',
    errorTitle: 'Veranstaltungen konnten nicht geladen werden',
    errorBody: 'Bitte versuchen Sie es später erneut.',
    noEventsTitle: 'Keine Veranstaltungen gefunden',
    noEventsFiltered: 'Versuchen Sie eine andere Suche oder einen anderen Filter.',
    noEventsEmpty: 'Schauen Sie bald wieder vorbei für neue Veranstaltungen.',
    soldOut: 'Ausverkauft',
    ticketsLeft: 'Noch {count} übrig',
    datesCount: '{count} Termine',
    getTickets: 'Tickets sichern',
    view: 'Ansehen',
  },
  eventDetail: {
    loading: 'Veranstaltung wird geladen...',
    notFoundTitle: 'Veranstaltung nicht gefunden',
    notFoundBody: 'Diese Veranstaltung existiert nicht mehr oder ist nicht mehr verfügbar.',
    backToEvents: 'Zurück zu den Veranstaltungen',
    allEvents: 'Alle Veranstaltungen',
    share: 'Teilen',
    linkCopied: 'Link kopiert!',
    copyLink: 'Link in die Zwischenablage kopieren',
    addToCalendar: 'Zum Kalender hinzufügen',
    icalOutlook: 'iCal / Outlook',
    googleCalendar: 'Google Kalender',
    onlineEventLabel: 'Online-Veranstaltung',
    whoIsAttending: 'Wer nimmt teil',
    loginRequiredBody: 'Die Teilnehmerliste ist nur für Ticketinhaber sichtbar. Melden Sie sich an, um zu sehen, wer kommt.',
    loginToView: 'Zum Ansehen anmelden',
    ticketRequiredBody: 'Die Teilnehmerliste ist nur für bestätigte Ticketinhaber sichtbar.',
    attendingCountOne: '{count} Person nimmt teil',
    attendingCountMany: '{count} Personen nehmen teil',
    hiddenCountOne: '+{count} Person hat sich entschieden, ihr Profil nicht anzuzeigen.',
    hiddenCountMany: '+{count} Personen haben sich entschieden, ihr Profil nicht anzuzeigen.',
    clickToSeeMore: 'Klicken für mehr Details',
    web: 'Web',
    linkedin: 'LinkedIn',
    tapToExpand: 'zum Erweitern antippen',
    free: 'Kostenlos',
    getTickets: 'Tickets sichern',
    pricePerTicket: '{price} pro Ticket',
    memberPriceApplied: 'Mitgliederpreis angewendet — Nichtmitglieder zahlen {price}',
    nonMemberPriceNote: 'Mitglieder zahlen {price} — mit einer Mitgliedschaft anmelden, um Ihren Preis zu sehen',
    selectDate: 'Termin auswählen',
    chooseADate: 'Termin wählen…',
    pleaseChooseDate: 'Bitte wählen Sie einen Termin, um fortzufahren.',
    ticketCount: '{count} Ticket{plural}',
    soldOut: 'Ausverkauft',
    soldOutButton: 'Ausverkauft',
    onlyXLeft: 'Nur noch {count} Ticket{plural} übrig!',
    ticketsRemaining: 'Noch {count} Tickets verfügbar',
    quantity: 'Anzahl',
    total: 'Gesamt:',
    continueToCheckout: 'Weiter zur Kasse',
    waitlistPrompt: 'Möchten Sie sich auf die Warteliste setzen lassen? Kontaktieren Sie den Veranstalter:',
    signInPrompt: 'Sie werden gebeten, sich anzumelden oder ein Konto zu erstellen.',
    moreEventsLikeThis: 'Weitere ähnliche Veranstaltungen',
  },
  conferenceList: {
    loading: 'Konferenzen werden geladen...',
    title: 'Kommende Konferenzen',
    searchPlaceholder: 'Konferenzen suchen…',
    errorTitle: 'Konferenzen konnten nicht geladen werden',
    errorBody: 'Bitte versuchen Sie es später erneut.',
    noConferencesTitle: 'Keine Konferenzen gefunden',
    noConferencesFiltered: 'Versuchen Sie eine andere Suche.',
    noConferencesEmpty: 'Schauen Sie bald wieder vorbei für neue Konferenzen.',
    soldOut: 'Ausverkauft',
    sessionsCount: '{count} Sitzungen',
    getPass: 'Pass sichern',
    view: 'Ansehen',
  },
  conferenceDetail: {
    loading: 'Konferenz wird geladen...',
    notFoundTitle: 'Konferenz nicht gefunden',
    notFoundBody: 'Diese Konferenz existiert nicht mehr oder ist nicht mehr verfügbar.',
    backToConferences: 'Zurück zu Konferenzen',
    allConferences: 'Alle Konferenzen',
    scheduleTitle: 'Programm',
    generalSchedule: 'Allgemeines Programm',
    live: 'Live',
    getPass: 'Pass sichern',
    passPrice: '{price} pro Pass',
    passIncludes: 'Ein Pass deckt jede Sitzung dieser Konferenz ab — keine separate Buchung nötig.',
    onlyXLeft: 'Nur noch {count} Pässe verfügbar!',
    soldOutButton: 'Ausverkauft',
    continueToCheckout: 'Weiter zur Kasse',
    signInPrompt: 'Sie werden gebeten, sich anzumelden oder ein Konto zu erstellen.',
  },
  checkout: {
    loading: 'Ihre Bestellung wird vorbereitet...',
    errorTitle: 'Checkout konnte nicht gestartet werden',
    goBack: 'Zurück',
    back: 'Zurück',
    title: 'Kasse',
    couponTitle: 'Haben Sie einen Gutscheincode?',
    couponPlaceholder: 'Code eingeben…',
    couponInvalid: 'Ungültiger oder abgelaufener Gutscheincode.',
    proceedToPayment: 'Weiter zur Zahlung',
    proceedErrorInit: 'Zahlung konnte nicht initialisiert werden. Bitte versuchen Sie es erneut.',
    proceedErrorGeneric: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
    invalidLink: 'Ungültiger Checkout-Link.',
    initError: 'Etwas ist schiefgelaufen. Bitte gehen Sie zurück und versuchen Sie es erneut.',
    paymentFailed: 'Die Zahlung konnte nicht abgeschlossen werden. Bitte versuchen Sie es erneut.',
    paymentDetails: 'Zahlungsdetails',
    couponApplied: 'Gutschein angewendet — {amount} Rabatt',
    payButton: '{amount} bezahlen',
    paymentNotConfigured: 'Für diese Veranstaltung sind keine Zahlungen konfiguriert. Bitte kontaktieren Sie den Veranstalter.',
    ticketsCount: '{count} Ticket{plural}',
    conferencePass: 'Konferenzpass',
    couponDiscount: 'Gutscheinrabatt: −{amount}',
    total: 'Gesamt: {amount}',
    orderRefLabel: 'Bestellreferenz:',
  },
  orderConfirmation: {
    loading: 'Ihre Bestellung wird geladen...',
    errorTitle: 'Bestellung nicht gefunden',
    errorBody: 'Wir konnten Ihre Bestellung nicht finden. Prüfen Sie Ihre Tickets unten.',
    viewMyTickets: 'Meine Tickets ansehen',
    tapToClose: 'Zum Schließen irgendwo antippen',
    title: 'Buchung bestätigt!',
    subtitle: 'Ihre Tickets wurden gebucht. Bis bald!',
    ticketsCount: '{count} Ticket{plural}',
    orderRefLabel: 'Bestellreferenz:',
    yourTicket: 'Ihr Ticket',
    yourTicketOf: 'Ihr Ticket (1 von {count})',
    tapToEnlarge: 'Zum Vergrößern antippen · An der Tür vorzeigen',
    allTicketsAvailable: 'Alle {count} Tickets sind unter „Meine Tickets“ verfügbar',
    share: 'Teilen',
    linkCopied: 'Link kopiert!',
    shareEventPage: 'Veranstaltungsseite teilen',
    browseMoreEvents: 'Weitere Veranstaltungen entdecken',
  },
  calendar: {
    today: 'Heute',
    moreCount: '+{count} weitere',
    mon: 'Mo',
    tue: 'Di',
    wed: 'Mi',
    thu: 'Do',
    fri: 'Fr',
    sat: 'Sa',
    sun: 'So',
  },
};
